import { Component, OnInit, Directive, ElementRef, AfterViewChecked, 
  Input, HostListener } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { HttpService } from '../http.service';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  title = 'Welcome to Bill\'s portfolio site | Bill\'s portfolio site';
  websites: Object;
  photos: Object;
  public errorMsg;

  /** ✅ 按需修改你的关键年份 */
  private readonly START_IN_TECH_YEAR = 2006;      // 入行年份（总年限）
  private readonly TRANSITION_TO_DEV_YEAR = 2013;  // 从 QA 转为开发/设计的年份
  private readonly GRAD_YEAR = 2012;               // BCIT 毕业年份

  /** 生成的简介文本（模板里直接 {{ intro }}） */
  intro = '';

  constructor(
    private titleService: Title,
    private metaService: Meta,
    private route: ActivatedRoute,
    private _http: HttpService,
    public router: Router,
  ) {}

  ngOnInit(): void {
    this.titleService.setTitle(this.title);

    // 计算年限并生成简介
    const yearsInTech = this.yearsSince(this.START_IN_TECH_YEAR);
    const yearsAsDev = this.yearsSince(this.TRANSITION_TO_DEV_YEAR);

    this.intro = `I am a Web Developer and Designer with over ${yearsInTech} years of experience in the computer field. ` +
      `I started as a QA engineer and transitioned to development and design more than ${yearsAsDev} years ago, ` +
      `after graduating from the British Columbia Institute of Technology in ${this.GRAD_YEAR}.\n\n` +
      `I specialize in full-stack web application development with a strong focus on eCommerce solutions. ` +
      `Over the years, I have built and integrated systems across platforms like Shopify, Magento, NetSuite, WordPress, Drupal, ShipStation, WindWard, and WebShop Manager.\n\n` +
      `My core technical expertise includes JavaScript, React, Angular, Backbone, PHP, Node.js, Express, HTML/CSS, and MySQL/MariaDB, ` +
      `with solid experience in UI/UX design, API integrations, and scalable architecture.`;

    // ✅ Meta 标签同样用动态年限，确保搜索引擎展示的是最新描述
    this.metaService.addTags([{ name: 'robots', content: 'index, follow' }]);
    this.metaService.updateTag({
      name: 'keywords',
      content:
        'Web developer, freelance, eCommerce, WordPress, Magento, NetSuite, Vancouver, Surrey, Richmond, Greater Vancouver, web development and design, Drupal, JavaScript, PHP, Bill Yin'
    });
    this.metaService.updateTag({
      name: 'description',
      content:
        `Bill Yin is a freelance web developer in Greater Vancouver, BC. With ${yearsInTech}+ years in the field and ${yearsAsDev}+ years focused on full-stack and eCommerce (Shopify, Magento, NetSuite, WordPress, Drupal), he builds performant, scalable applications using JavaScript, React/Angular, Node.js/Express, PHP, and MySQL/MariaDB.`
    });

    this._http.getWebsites('all', 4).subscribe(
      data => this.websites = data,
      error => this.errorMsg = error
    );

    this._http.getPhotos('all', 4).subscribe(
      data => this.photos = data,
      error => this.errorMsg = error
    );
  }

  /** 计算从某年到当前年的年数 */
  private yearsSince(year: number): number {
    return Math.max(0, new Date().getFullYear() - year);
  }

  onSelect(item) {
    this.router.navigate(
      ['/web/' + item.url, { type: item.item_category, postType: 'websites' }],
      { relativeTo: this.route }
    );
  }

  onSelectPotography(item) {
    this.router.navigate(
      ['/photography/' + item.url, { type: item.item_category, postType: 'photography' }],
      { relativeTo: this.route }
    );
  }
}
